import React from 'react'

import { Route, useParams } from 'react-router-dom'

import { Box, Paper, Stepper, Step, StepLabel } from '@material-ui/core'

import { routes } from 'routes'
import { Container } from 'components'
import useWindowSize from 'hooks/useWindowSize'
import PaymentMethodsIntegrationToken from './PaymentMethodsIntegrationToken'
import PaymentMethodsSelectMethods from './PaymentMethodsSelectMethods'
import PaymentMethodsConfiguration from './PaymentMethodsConfiguration'

const PaymentMethodsSteps = () => {
  const params = useParams()
  const windowSize = useWindowSize()

  const routesSteps = React.useMemo(
    () => [
      routes.settings.paymentMethods.steps.integrationToken,
      routes.settings.paymentMethods.steps.selectMethods,
      routes.settings.paymentMethods.steps.configuration,
    ],
    [],
  )

  const activeStep = React.useMemo(
    () => routesSteps.findIndex(step => step.includes(params.step)),
    [routesSteps, params.step],
  )

  return (
    <Container>
      <Box component={Paper} overflow="hidden">
        <Stepper activeStep={activeStep}>
          <Step>
            <StepLabel>
              {windowSize.isDesktop ? 'Token de integração' : ''}
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>
              {windowSize.isDesktop ? 'Formas de pagamento' : ''}
            </StepLabel>
          </Step>
          <Step>
            <StepLabel>{windowSize.isDesktop ? 'Configurações' : ''}</StepLabel>
          </Step>
        </Stepper>

        <Box p={3} overflow="hidden">
          <Route
            path={routes.settings.paymentMethods.steps.integrationToken}
            component={PaymentMethodsIntegrationToken}
          />

          <Route
            path={routes.settings.paymentMethods.steps.selectMethods}
            component={PaymentMethodsSelectMethods}
          />

          <Route
            path={routes.settings.paymentMethods.steps.configuration}
            component={PaymentMethodsConfiguration}
          />
        </Box>
      </Box>
    </Container>
  )
}

export default PaymentMethodsSteps
